/* @flow */
import React, { useState, useCallback } from 'react';
import { withTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import IconButton from '../IconButton';

import type { Translate } from '../../types';

type Props = {
  children?: any,
  title?: string,
  loading?: boolean,
  onRefresh?: () => mixed,
  onAdd?: () => mixed,
  onAsk?: () => mixed,
  t: Translate,
};

type State = {
  isExpanded: boolean,
};

class Sidebar extends React.PureComponent<Props, State> {
  state = {
    isExpanded: true,
  };

  render() {
    const handleExpandClick = () => {
      this.setState({ isExpanded: !this.state.isExpanded });
    };
    const { children, title = '', loading = false, onRefresh, onAdd, onAsk, t } = this.props;
    const { isExpanded } = this.state;
    return (
      <div className={isExpanded ? styles.side : styles.sideCollapsed}>
        <div className={isExpanded ? styles.section : styles.sectionCollapsed}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionHeaderTitle}>{title}</div>
            <div className={styles.sectionHeaderButtons}>
              {onRefresh && (
                <IconButton
                  icon={'refresh'}
                  tooltip={t('REFRESH')}
                  disabled={loading}
                  onClick={onRefresh}
                />
              )}
              {onAdd && (
                <IconButton icon={'plus'} tooltip={t('ADD')} disabled={loading} onClick={onAdd} />
              )}
              {onAsk && (
                <IconButton
                  icon={'question'}
                  tooltip={t('ASK_REQUEST')}
                  disabled={loading}
                  onClick={onAsk}
                />
              )}
              <IconButton
                icon={'chevron_left'}
                tooltip={t('COLLAPSE')}
                disabled={loading}
                onClick={handleExpandClick}
              />
            </div>
          </div>
          <div className={styles.sectionContent}>{children}</div>
        </div>
        {!isExpanded && (
          <div className={styles.buttonCollapse} onClick={handleExpandClick}>
            <IconButton icon={'chevron_right'} tooltip={t('EXPAND')} disabled={loading} />
          </div>
        )}
      </div>
    );
  }
}

type SectionProps = {
  children?: any,
  disabled?: boolean,
  title?: any,
  loading?: boolean,
  buttons?: any,
  t: Translate,
};

export const SidebarSection = withTranslation()((props: SectionProps) => {
  const { children, disabled = false, loading, title, buttons, t } = props;
  const [isSectionExpanded, setIsSectionExpanded] = useState(true);
  const toggleIsSectionExpanded = useCallback(() => {
    setIsSectionExpanded(isSectionExpanded => !isSectionExpanded);
  }, [setIsSectionExpanded]);
  return (
    <div className={styles.sidebarSection}>
      <div className={styles.sidebarSectionHeader}>
        <div
          className={
            disabled ? styles.sidebarSectionHeaderTitleDisabled : styles.sidebarSectionHeaderTitle
          }
        >
          {title}
        </div>
        <div className={styles.sidebarSectionHeaderButtons}>
          {buttons}
          <IconButton
            icon={isSectionExpanded ? 'chevron_up' : 'chevron_down'}
            tooltip={isSectionExpanded ? t('COLLAPSE') : t('EXPAND')}
            disabled={loading}
            onClick={toggleIsSectionExpanded}
          />
        </div>
      </div>
      <div
        style={isSectionExpanded ? {} : { display: 'none' }}
        className={styles.sidebarSectionContent}
      >
        {children}
      </div>
    </div>
  );
});

export default withTranslation()(Sidebar);
